import {
  useGetRouteQueuesDayRangeQuery,
  useGetRouteQueuesQuery,
} from 'state/apiSlice';
import { useAppSelector } from 'state/hooks';
import {
  selectComparison,
  selectProject,
  selectTargetDate,
  selectTargetEndDate,
  selectUseDayRange,
} from 'state/workflowSlice';

import { useRouteInfo } from 'features/common/hooks/useRouteInfo';
import { isComparisonMonth } from 'features/task_bar/ComparisonPicker';

export function useQueueDataProvider(skip = false) {
  const project_slug = useAppSelector(selectProject);
  const targetDate = useAppSelector(selectTargetDate);
  const targetEndDate = useAppSelector(selectTargetEndDate);
  const comparison = useAppSelector(selectComparison);
  const useDayRange = useAppSelector(selectUseDayRange);

  const { basicRouteInfo } = useRouteInfo();

  if (useDayRange) {
    return useGetRouteQueuesDayRangeQuery(
      {
        project_slug,
        routeIds: basicRouteInfo.realizedSegments,
        startDate: targetDate,
        endDate: targetEndDate,
        comparison_ym: comparison,
      },
      {
        skip:
          skip ||
          !isComparisonMonth(comparison) ||
          !basicRouteInfo.realizedSegments,
      },
    );
  } else {
    return useGetRouteQueuesQuery(
      {
        project_slug,
        routeIds: basicRouteInfo.realizedSegments,
        date: targetDate,
        comparison_ym: comparison,
      },
      {
        skip:
          skip ||
          !isComparisonMonth(comparison) ||
          !basicRouteInfo.realizedSegments,
      },
    );
  }
}
